import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class NoCache implements HttpInterceptor {

    constructor() { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.url.includes('tech.octa.com.br')) {
            request = request.clone({
                setHeaders: {
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                },
            });
        }

        return next.handle(request);
    }
}
